<template>
    <transition name="lightbox-fade" v-if="show">
        <div class="lightbox-backdrop">
            <div class="lightbox"
                 :id="id"
                 role="dialog"
                 :aria-labelledby="id + '_lightboxTitle'"
                 :aria-describedby="id + '_lightboxTitle'">
                <header class="lightbox-header"
                        :id="id + '_lightboxTitle'">
                    <div class="lightbox-close-container">
                        <button type="button"
                                class="lightbox-close"
                                @click="close"
                                aria-label="Close Lightbox">
                                <svg xmlns='http://www.w3.org/2000/svg' width='19' height='19'><path fill='none' stroke='#FFF' stroke-linecap='square' d='M9.5 9.5L1.283 1.283 9.5 9.5l-8.217 8.217L9.5 9.5zm0 0l8.256 8.256L9.5 9.5l8.256-8.256L9.5 9.5z'/></svg>
                            </button>
                    </div>
                    <div class="lightbox-header-content">
                        <slot name="header"></slot>
                    </div>

                </header>
                <section class="lightbox-body"
                         :id="id + '_lightboxDescription'">
                    <slot name="body"></slot>
                </section>
                <footer class="lightbox-footer">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: "LightBox",
        props: [
            'id',
            'show'
        ],
        methods: {
            close() {
                this.$emit('close');
            }
        },
        watch: {
            show: function (newVal) { // watch it
                var htmlElement = document.getElementsByTagName('html')[0];
                if (newVal === true) {
                    htmlElement.classList.add('lightbox-open');
                }
                else {
                    htmlElement.classList.remove('lightbox-open');
                }
            }
        }
    }
</script>